import { adminClient as apolloClient } from '@/store/apollo';

import TagsGql from '@/extensions/shop/store/graphql/queries/Tags.gql';

export default {
    fetchList: (shopID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: TagsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_Tags))
                .catch(err => reject(err));
        })
};
